import API_ENDPOINTS from '../config/apiEndpoints';

/**
 * Service to handle Conversion module data fetching
 */

export const getConversionList = async (params) => {
    try {
        const url = 'https://serviceskit19.azurewebsites.net/UserCRM/UserConversionsList';
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching conversion list:', error);
        throw error;
    }
};

export const getConversionDetail = async (payload) => {
    try {
        const url = 'https://serviceskit19.azurewebsites.net/UserCRM/GetUserConversionDetail';
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching conversion detail:', error);
        throw error;
    }
};
